export const TRIAL_APP_IOS = 'https://apps.apple.com/app/id926738507';
export const TRIAL_APP_ANDROID = 'https://play.google.com/store/apps/details?id=com.flexappeal.mobile.app.release';
export const TRIAL_APP_ANDROID_PACKAGE = 'com.flexappeal.mobile.app.release';
export const TRIAL_APP_IOS_SCHEME = 'flexappeal';
export const TRIAL_APP_PATH = '/free-trial/app';
export const TRIAL_APP_STORE_FALLBACK_MS = 1400;

export function trialAppStoreUrl(userAgent: string): string | null {
  if (/iPhone|iPad|iPod/i.test(userAgent)) return TRIAL_APP_IOS;
  if (/Android/i.test(userAgent)) return TRIAL_APP_ANDROID;

  return null;
}

export function trialNativeLaunchUrl(userAgent: string): string | null {
  const storeUrl = trialAppStoreUrl(userAgent);

  if (!storeUrl) return null;

  if (/Android/i.test(userAgent)) {
    return [
      'intent:#Intent',
      'action=android.intent.action.MAIN',
      'category=android.intent.category.LAUNCHER',
      `package=${TRIAL_APP_ANDROID_PACKAGE}`,
      `S.browser_fallback_url=${encodeURIComponent(storeUrl)}`,
      'end',
    ].join(';');
  }

  return `${TRIAL_APP_IOS_SCHEME}://open`;
}

export function trialAppDownloadUrl(origin?: string): string {
  const host = origin || (typeof window === 'undefined' ? '' : window.location.origin);

  return host ? `${host}${TRIAL_APP_PATH}` : TRIAL_APP_PATH;
}
